import { Box, Container } from "@mui/material";
import React from "react";
import Post from "./Post";

const ProfilePosts = ({ posts }) => {
  return (
    <Container
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      {posts.map((p) => (
        <Post key={p._id} post={p} />
      ))}
    </Container>
  );
};

export default ProfilePosts;
